// The first message Clyde sends on a new thread. One copy, shared by the server
// (createClydeThread sends it) and the admin's "Start a Clyde thread" dialog
// (which previews it) — the preview and the sent text can never drift apart.
//
// Wording is Jon's (2026-10-21, second revision, verbatim — only the names are
// filled in; his double space after "order summary." is normalised to one). No
// START/STOP lines: threads are started for clients who already agreed to order
// by text. STOP still works (the webhook's keyword gate), and a buyer with no
// consent on file gets the opt-in prompt on their first order text, so nothing
// is parsed without consent. The 1:1 text (no rep) is the minimal cut of the
// group text — Jon gave none.

export interface ThreadIntroParams {
  agentName: string;
  accountName: string;
  /** A rep is in the thread (SMS group). */
  group: boolean;
  /** What the buyer calls the rep; first name used, as the console's "Kyle: …". */
  repName?: string | null;
}

export function buildThreadIntro(p: ThreadIntroParams): string {
  const hello = `Hi ${p.accountName} - ${p.agentName} here`;
  if (!p.group) {
    return `${hello}. Text your orders to this number. I'll confirm with you, then write it up in our system and send you an order summary.`;
  }
  const rep = (p.repName ?? '').trim().split(/\s+/)[0] || 'your rep';
  return `${hello} (and I'm adding ${rep} too). Text your orders in this thread. I'll confirm with you, then write it up in our system and send you an order summary. I'll mostly keep quiet until I see an order or my name - the rest I'll leave to ${rep}.`;
}
